import { useRouter } from "next/router";
import { useEffect } from "react";

const Index = () => {
  const router = useRouter();

  useEffect(() => {
    router.push("/power-app-transactions");
  });

  return <div> Loading... </div>;
};

Index.isAuth = true;
export default Index;
